import { Injectable } from '@angular/core';
import {Endpoints} from "../../customs/endpoints";
import {HttpClient} from "@angular/common/http";
import {CommonResponse} from "../../customs/_models/Response";
import {TerrainDTO} from "../../customs/_models/terrain.dto";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TerrrainService {
filteredTerrains: any;

  constructor(
               private endpoints: Endpoints,
               private http : HttpClient) { }


    public saveTerrain(terrain : TerrainDTO) : Observable<CommonResponse>{
      return this.http.post<CommonResponse>(this.endpoints.client_terrain_base_endpoint, terrain );
    }

    findAll() {
        return this.http.get<CommonResponse>(this.endpoints.client_terrain_base_endpoint)
    }

    findById(id:number) {
      return this.http.get<CommonResponse>(`${this.endpoints.client_terrain_base_endpoint}/${id}`);
    }

   findByClientId(clientId: number): Observable<CommonResponse> {
    return this.http.get<CommonResponse>(`${this.endpoints.client_terrain_base_endpoint}/getByClientId/${clientId}`);
  }
}
